import $ from "jquery";
$(document).ready(function () {
    if ($('.page-template-tpl-presentation').length || $('.page-template-tpl-home').length) {
        $('.actions').on("click", 'a[href="#choice-selector"], a[href="#choice"]', function (e) {
            e.preventDefault();
            $('header .actions .choice').toggleClass("open");
            if ($(e.currentTarget).attr("href") == "#choice") {
                $('header .actions .choice').find("li").removeClass("selected");
                $(e.currentTarget).parent().addClass("selected");
                $('header .actions .link').attr("href", $(e.currentTarget).parent().attr("data-choice"));
            }
        });
    }
    $('#restaurants-choice').hide().css({ opacity: 1 });
    $('#restaurants-choice').on("click", 'a[href="#choice-selector"], a[href="#choice"]', function (e) {
        e.preventDefault();
        $('#restaurants-choice .choice').toggleClass("open");
        if ($(e.currentTarget).attr("href") == "#choice") {
            $('#restaurants-choice .choice').find("li").removeClass("selected");
            $(e.currentTarget).parent().addClass("selected");
            $('#restaurants-choice .link').attr("href", $(e.currentTarget).parent().attr("data-choice"));
        }
    });
    $('#restaurants-choice').on("click", "a.close", function (e) {
        e.preventDefault();
        $('#restaurants-choice').fadeOut(250);
    });
    $('.order-choice').on("click", function (e) {
        if ($(".Cart.preview.cart-mini-contents .count").html() == "0") {
            e.preventDefault();
            $('#restaurants-choice').fadeIn();
        }
    });
});
